/* global jQuery COMPONENTS */
COMPONENTS.componentEvent = (function ($) {
  function componentEvent () {
    this.calendarWrap = document.getElementById('ecs-events-calender')
    this.$calendar = $(this.calendarWrap)
  }

  componentEvent.prototype.init = function () {
    const viewportTablet = window.matchMedia('(min-width: 768px)')
    const viewportLaptop = window.matchMedia('(min-width: 1024px)')

    // Check if there is an Events Calendar component
    if ($('#ecs-events-calender').length) {
      function handleResizeLogic(info) {
        // Mobile Only Function
        if (!viewportTablet.matches) {
          // Tablet and Above Only Function

          // Scroll to the mini card clicked
          let $eventCard = $('#' + info.event.id)
          $eventCard[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          // Remove all active states
          $('.ec-day').removeClass('ecs_active')
          $('.ecs_event_mini_card').removeClass('ecs_active')

          // Add active state to mini card and calendar day
          $(info.el).parent().parent().addClass('ecs_active')
          $eventCard.addClass('ecs_active')
        } else if (viewportTablet.matches) {
          // When an event is is clicked, navigate to a new URL
          let currentURL = $(location).attr('href')
          window.location.href = currentURL + '/' + info.event.id
        }
      }

      let ec = EventCalendar.create(document.getElementById('ecs-events-calender'), {
        view: 'dayGridMonth',
        events: events,
        editable: false,
        eventStartEditable: false,
        eventDurationEditable: false,
        eventClick: function (info) {
          handleResizeLogic(info)
        }
      })
    }
  }

  return componentEvent
})(jQuery)

document.addEventListener('components_init', function (e) {
  COMPONENTS.componentEvent = new COMPONENTS.componentEvent()
  COMPONENTS.componentEvent.init()
})
